"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8111],{

/***/ 288111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ Accordion_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(320129);
// EXTERNAL MODULE: ./node_modules/@tamagui/animate-presence/dist/esm/AnimatePresence.mjs + 3 modules
var AnimatePresence = __webpack_require__(126062);
// EXTERNAL MODULE: ./node_modules/@tamagui/use-presence/dist/esm/index.mjs + 2 modules
var esm = __webpack_require__(661360);
// EXTERNAL MODULE: ./node_modules/@tamagui/helpers/dist/esm/index.mjs + 5 modules
var dist_esm = __webpack_require__(247533);
// EXTERNAL MODULE: ./node_modules/@tamagui/use-controllable-state/dist/esm/useControllableState.mjs
var useControllableState = __webpack_require__(481430);
// EXTERNAL MODULE: ./node_modules/@tamagui/web/dist/cjs/index.js
var cjs = __webpack_require__(117187);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
;// CONCATENATED MODULE: ./node_modules/@tamagui/collapsible/dist/jsx/Collapsible.js






const COLLAPSIBLE_NAME = "Collapsible", { Provider: CollapsibleProvider, useStyledContext: useCollapsibleContext } = (0,cjs.createStyledContext)(), _Collapsible = react.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeCollapsible,
      open: openProp,
      defaultOpen,
      disabled,
      onOpenChange,
      ...collapsibleProps
    } = props, [open = !1, setOpen] = (0,useControllableState/* useControllableState */.T)({
      prop: openProp,
      defaultProp: defaultOpen,
      onChange: onOpenChange
    });
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      CollapsibleProvider,
      {
        scope: __scopeCollapsible,
        disabled,
        contentId: react.useId(),
        open,
        onOpenToggle: react.useCallback(
          () => setOpen((prevOpen) => !prevOpen),
          [setOpen]
        ),
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
          cjs.Stack,
          {
            "data-state": getState(open),
            "data-disabled": disabled ? "" : void 0,
            ...collapsibleProps,
            ref: forwardedRef
          }
        )
      }
    );
  }
);
_Collapsible.displayName = COLLAPSIBLE_NAME;
const TRIGGER_NAME = "CollapsibleTrigger", CollapsibleTriggerFrame = (0,cjs.styled)(cjs.Stack, {
  name: TRIGGER_NAME,
  tag: "button"
}), CollapsibleTrigger = CollapsibleTriggerFrame.styleable(
  (props, forwardedRef) => {
    const { __scopeCollapsible, children, ...triggerProps } = props, context = useCollapsibleContext(__scopeCollapsible);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      CollapsibleTriggerFrame,
      {
        "aria-controls": context.contentId,
        "aria-expanded": context.open || !1,
        "data-state": getState(context.open),
        "data-disabled": context.disabled ? "" : void 0,
        disabled: context.disabled,
        ...triggerProps,
        ref: forwardedRef,
        onPress: (0,dist_esm/* composeEventHandlers */.Mj)(props.onPress, context.onOpenToggle),
        children: typeof children == "function" ? children({ open: context.open }) : children
      }
    );
  }
);
CollapsibleTrigger.displayName = TRIGGER_NAME;
const CONTENT_NAME = "CollapsibleContent", CollapsibleContentFrame = (0,cjs.styled)(cjs.Stack, {
  name: CONTENT_NAME
}), CollapsibleContent = CollapsibleContentFrame.styleable(
  (props, forwardedRef) => {
    const {
      forceMount,
      children,
      // @ts-expect-error
      __scopeCollapsible,
      ...contentProps
    } = props, context = useCollapsibleContext(__scopeCollapsible);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, { ...contentProps, children: forceMount || context.open ? /* @__PURE__ */ (0,jsx_runtime.jsx)(CollapsibleContentFrame, { ref: forwardedRef, ...contentProps, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(esm/* ResetPresence */.il, { children }) }) : null });
  }
);
CollapsibleContent.displayName = CONTENT_NAME;
function getState(open) {
  return open ? "open" : "closed";
}
const Collapsible = (0,dist_esm/* withStaticProperties */.$e)(_Collapsible, {
  Trigger: CollapsibleTrigger,
  Content: CollapsibleContent
});

//# sourceMappingURL=Collapsible.js.map

// EXTERNAL MODULE: ./node_modules/@tamagui/collection/dist/esm/Collection.mjs
var Collection = __webpack_require__(609053);
// EXTERNAL MODULE: ./node_modules/@tamagui/compose-refs/dist/esm/compose-refs.mjs
var compose_refs = __webpack_require__(594030);
// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs + 1 modules
var constants_dist_esm = __webpack_require__(275425);
// EXTERNAL MODULE: ./node_modules/@tamagui/stacks/dist/esm/Stacks.mjs
var Stacks = __webpack_require__(743702);
// EXTERNAL MODULE: ./node_modules/@tamagui/text/dist/esm/Headings.mjs
var Headings = __webpack_require__(692976);
// EXTERNAL MODULE: ./node_modules/@tamagui/use-direction/dist/esm/index.mjs + 1 modules
var use_direction_dist_esm = __webpack_require__(438497);
;// CONCATENATED MODULE: ./node_modules/@tamagui/accordion/dist/jsx/Accordion.js
/* provided dependency */ var process = __webpack_require__(734155);













const ACCORDION_NAME = "Accordion", ACCORDION_KEYS = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Accordion_Collection, useCollection] = (0,Collection/* createCollection */.B)(ACCORDION_NAME), ACCORDION_CONTEXT = "Accordion", AccordionComponent = react.forwardRef((props, forwardedRef) => {
  const { type, ...accordionProps } = props, singleProps = accordionProps, multipleProps = accordionProps;
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(Accordion_Collection.Provider, { __scopeCollection: props.__scopeAccordion || ACCORDION_CONTEXT, children: type === "multiple" ? /* @__PURE__ */ (0,jsx_runtime.jsx)(AccordionImplMultiple, { ...multipleProps, ref: forwardedRef }) : /* @__PURE__ */ (0,jsx_runtime.jsx)(AccordionImplSingle, { ...singleProps, ref: forwardedRef }) });
});
AccordionComponent.displayName = ACCORDION_NAME;
AccordionComponent.propTypes = {
  type(props) {
    const value = props.value || props.defaultValue;
    return props.type && !["single", "multiple"].includes(props.type) ? new Error(
      "Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`."
    ) : props.type === "multiple" && typeof value == "string" ? new Error(
      "Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`."
    ) : props.type === "single" && Array.isArray(value) ? new Error(
      "Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`."
    ) : null;
  }
};
const { Provider: AccordionValueProvider, useStyledContext: useAccordionValueContext } = (0,cjs.createStyledContext)(), {
  Provider: AccordionCollapsibleProvider,
  useStyledContext: useAccordionCollapsibleContext
} = (0,cjs.createStyledContext)(), AccordionImplSingle = react.forwardRef((props, forwardedRef) => {
  const {
    value: valueProp,
    defaultValue,
    control,
    onValueChange = () => {
    },
    collapsible = !1,
    ...accordionSingleProps
  } = props, [value, setValue] = (0,useControllableState/* useControllableState */.T)({
    prop: valueProp,
    defaultProp: defaultValue || "",
    onChange: onValueChange
  });
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    AccordionValueProvider,
    {
      scope: props.__scopeAccordion,
      value: value ? [value] : [],
      onItemOpen: setValue,
      onItemClose: react.useCallback(
        () => collapsible && setValue(""),
        [setValue, collapsible]
      ),
      children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
        AccordionCollapsibleProvider,
        {
          scope: props.__scopeAccordion,
          collapsible,
          children: /* @__PURE__ */ (0,jsx_runtime.jsx)(AccordionImpl, { ...accordionSingleProps, ref: forwardedRef })
        }
      )
    }
  );
}), AccordionImplMultiple = react.forwardRef((props, forwardedRef) => {
  const {
    value: valueProp,
    defaultValue,
    onValueChange = () => {
    },
    ...accordionMultipleProps
  } = props, [value, setValue] = (0,useControllableState/* useControllableState */.T)({
    prop: valueProp,
    defaultProp: defaultValue || [],
    onChange: onValueChange
  }), handleItemOpen = react.useCallback(
    (itemValue) => setValue((prevValue = []) => [...prevValue, itemValue]),
    [setValue]
  ), handleItemClose = react.useCallback(
    (itemValue) => setValue((prevValue = []) => prevValue.filter((value2) => value2 !== itemValue)),
    [setValue]
  );
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    AccordionValueProvider,
    {
      scope: props.__scopeAccordion,
      value: value || [],
      onItemOpen: handleItemOpen,
      onItemClose: handleItemClose,
      children: /* @__PURE__ */ (0,jsx_runtime.jsx)(AccordionCollapsibleProvider, { scope: props.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(AccordionImpl, { ...accordionMultipleProps, ref: forwardedRef }) })
    }
  );
}), { Provider: AccordionImplProvider, useStyledContext: useAccordionContext } = (0,cjs.createStyledContext)(), AccordionImpl = react.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeAccordion,
      disabled,
      dir,
      orientation = "vertical",
      ...accordionProps
    } = props, accordionRef = react.useRef(null), composedRef = (0,compose_refs/* useComposedRefs */.ex)(accordionRef, forwardedRef), getItems = useCollection(__scopeAccordion || ACCORDION_CONTEXT), isDirectionLTR = (0,use_direction_dist_esm/* useDirection */.gm)(dir) === "ltr", handleKeyDown = (0,dist_esm/* composeEventHandlers */.Mj)(
      props.onKeyDown,
      (event) => {
        if (!ACCORDION_KEYS.includes(event.key)) return;
        const target = event.target, triggerCollection = getItems().filter((item) => !item.ref.current?.disabled), triggerIndex = triggerCollection.findIndex(
          (item) => item.ref.current === target
        ), triggerCount = triggerCollection.length;
        if (triggerIndex === -1) return;
        event.preventDefault();
        let nextIndex = triggerIndex;
        const homeIndex = 0, endIndex = triggerCount - 1, moveNext = () => {
          nextIndex = triggerIndex + 1, nextIndex > endIndex && (nextIndex = homeIndex);
        }, movePrev = () => {
          nextIndex = triggerIndex - 1, nextIndex < homeIndex && (nextIndex = endIndex);
        };
        switch (event.key) {
          case "Home":
            nextIndex = homeIndex;
            break;
          case "End":
            nextIndex = endIndex;
            break;
          case "ArrowRight":
            orientation === "horizontal" && (isDirectionLTR ? moveNext() : movePrev());
            break;
          case "ArrowDown":
            orientation === "vertical" && moveNext();
            break;
          case "ArrowLeft":
            orientation === "horizontal" && (isDirectionLTR ? movePrev() : moveNext());
            break;
          case "ArrowUp":
            orientation === "vertical" && movePrev();
            break;
        }
        const clampedIndex = nextIndex % triggerCount;
        triggerCollection[clampedIndex].ref.current?.focus();
      }
    );
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      AccordionImplProvider,
      {
        scope: __scopeAccordion,
        disabled,
        direction: dir,
        orientation,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Accordion_Collection.Slot, { __scopeCollection: __scopeAccordion || ACCORDION_CONTEXT, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
          Stacks/* YStack */.FA,
          {
            "data-orientation": orientation,
            ref: composedRef,
            ...accordionProps,
            ...constants_dist_esm/* isWeb */.$L && {
              onKeyDown: handleKeyDown
            }
          }
        ) })
      }
    );
  }
), ITEM_NAME = "AccordionItem", { Provider: AccordionItemProvider, useStyledContext: useAccordionItemContext } = (0,cjs.createStyledContext)(), AccordionItem = react.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAccordion, value, ...accordionItemProps } = props, accordionContext = useAccordionContext(__scopeAccordion), valueContext = useAccordionValueContext(__scopeAccordion), triggerId = react.useId(), open = value && valueContext.value.includes(value) || !1, disabled = accordionContext.disabled || props.disabled;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      AccordionItemProvider,
      {
        scope: __scopeAccordion,
        open,
        disabled,
        triggerId,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
          Collapsible,
          {
            "data-orientation": accordionContext.orientation,
            "data-state": open ? "open" : "closed",
            __scopeCollapsible: __scopeAccordion || ACCORDION_CONTEXT,
            ...accordionItemProps,
            ref: forwardedRef,
            disabled,
            open,
            onOpenChange: (open2) => {
              open2 ? valueContext.onItemOpen(value) : valueContext.onItemClose(value);
            }
          }
        )
      }
    );
  }
);
AccordionItem.displayName = ITEM_NAME;
const HEADER_NAME = "AccordionHeader", AccordionHeader = react.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAccordion, ...headerProps } = props, accordionContext = useAccordionContext(__scopeAccordion), itemContext = useAccordionItemContext(__scopeAccordion);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      Headings.H1,
      {
        "data-orientation": accordionContext.orientation,
        "data-state": Accordion_getState(itemContext.open),
        "data-disabled": itemContext.disabled ? "" : void 0,
        ...headerProps,
        ref: forwardedRef
      }
    );
  }
);
AccordionHeader.displayName = HEADER_NAME;
const AccordionTriggerFrame = (0,cjs.styled)(Collapsible.Trigger, {
  variants: {
    unstyled: {
      false: {
        cursor: "pointer",
        backgroundColor: "$background",
        borderColor: "$borderColor",
        borderWidth: 1,
        padding: "$true",
        hoverStyle: {
          backgroundColor: "$backgroundHover"
        },
        focusStyle: {
          backgroundColor: "$backgroundFocus"
        },
        pressStyle: {
          backgroundColor: "$backgroundPress"
        }
      }
    }
  },
  defaultVariants: {
    unstyled: process.env.TAMAGUI_HEADLESS === "1"
  }
}), AccordionTrigger = AccordionTriggerFrame.styleable(function(props, forwardedRef) {
  const { __scopeAccordion, ...triggerProps } = props, accordionContext = useAccordionContext(__scopeAccordion), itemContext = useAccordionItemContext(__scopeAccordion), collapsibleContext = useAccordionCollapsibleContext(__scopeAccordion);
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(Accordion_Collection.ItemSlot, { __scopeCollection: __scopeAccordion || ACCORDION_CONTEXT, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
    AccordionTriggerFrame,
    {
      __scopeCollapsible: __scopeAccordion || ACCORDION_CONTEXT,
      "aria-disabled": itemContext.open && !collapsibleContext.collapsible || void 0,
      "data-orientation": accordionContext.orientation,
      id: itemContext.triggerId,
      ...triggerProps,
      ref: forwardedRef
    }
  ) });
}), AccordionContentFrame = (0,cjs.styled)(Collapsible.Content, {
  variants: {
    unstyled: {
      false: {
        padding: "$true",
        backgroundColor: "$background"
      }
    }
  },
  defaultVariants: {
    unstyled: process.env.TAMAGUI_HEADLESS === "1"
  }
}), AccordionContent = AccordionContentFrame.styleable(function(props, forwardedRef) {
  const { __scopeAccordion, ...contentProps } = props, accordionContext = useAccordionContext(__scopeAccordion), itemContext = useAccordionItemContext(__scopeAccordion);
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    AccordionContentFrame,
    {
      role: "region",
      "aria-labelledby": itemContext.triggerId,
      "data-orientation": accordionContext.orientation,
      __scopeCollapsible: __scopeAccordion || ACCORDION_CONTEXT,
      ...contentProps,
      ref: forwardedRef
    }
  );
}), HeightAnimator = cjs.View.styleable((props, ref) => {
  const itemContext = useAccordionItemContext(), { children, ...rest } = props, [height, setHeight] = react.useState(0);
  react.useEffect(() => {
    itemContext.open || setHeight(0);
  }, [itemContext.open]);
  const onLayout = (0,cjs.useEvent)(({ nativeEvent }) => {
    nativeEvent.layout.height && setHeight(nativeEvent.layout.height);
  });
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(cjs.View, { ref, height, ...rest, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
    cjs.View,
    {
      position: "absolute",
      width: "100%",
      onLayout,
      children
    }
  ) });
});
function Accordion_getState(open) {
  return open ? "open" : "closed";
}
const Accordion = (0,dist_esm/* withStaticProperties */.$e)(AccordionComponent, {
  Trigger: AccordionTrigger,
  Header: AccordionHeader,
  Content: AccordionContent,
  Item: AccordionItem,
  HeightAnimator
});

//# sourceMappingURL=Accordion.js.map

// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var dist_cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/ChevronDown.js
var ChevronDown = __webpack_require__(284359);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/analytics.js + 1 modules
var analytics = __webpack_require__(60368);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/useObservabilitySafe.js
var useObservabilitySafe = __webpack_require__(201252);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(646523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Animated/index.js + 64 modules
var Animated = __webpack_require__(953089);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Easing/index.js + 2 modules
var Easing = __webpack_require__(763988);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Accordion/HeightAnimator.js




var HeightAnimator_HeightAnimator = function(param) {
    var isOpen = param.isOpen, children = param.children;
    var height = (0,react.useRef)(new Animated/* default.Value */.Z.Value(0)), setHeight = function(toValue) {
        Animated/* default.timing */.Z.timing(height.current, {
            toValue: toValue,
            // TODO: see if we can use tokens for animation values
            duration: 100,
            easing: Easing/* default.bezier */.Z.bezier(0.42, 0, 1, 1),
            useNativeDriver: !1
        }).start();
    };
    (0,react.useEffect)(function() {
        isOpen || setHeight(0);
    }, [
        isOpen
    ]);
    var onLayout = (0,dist_cjs.useEvent)(function(param) {
        var nativeEvent = param.nativeEvent;
        isOpen && nativeEvent.layout.height && setHeight(nativeEvent.layout.height);
    });
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Animated/* default.View */.Z.View, {
        style: {
            height: height.current
        },
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(dist_cjs.View, {
            position: "absolute",
            left: 0,
            right: 0,
            onLayout: onLayout,
            children: children
        })
    });
};


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Accordion/Accordion.js












var accordionTokens = Components/* tokens.accordion */.T.accordion, Accordion_Accordion = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var analyticsName = _param.analyticsName, _trackImpression = _param.trackImpression, trackImpression = _trackImpression === void 0 ? !1 : _trackImpression, inViewThreshold = _param.inViewThreshold, showDivider = _param.showDivider, _showBottomDivider = _param.showBottomDivider, showBottomDivider = _showBottomDivider === void 0 ? !0 : _showBottomDivider, isFullWidth = _param.isFullWidth, _variant = _param.variant, variant = _variant === void 0 ? "regular" : _variant, disabled = _param.disabled, items = _param.items, _titleAlign = _param.titleAlign, titleAlign = _titleAlign === void 0 ? "left" : _titleAlign, _orientation = _param.orientation, orientation = _orientation === void 0 ? "top" : _orientation, _defaultOpen = _param.defaultOpen, defaultOpen = _defaultOpen === void 0 ? !1 : _defaultOpen, propsIn = (0,_object_without_properties/* default */.Z)(_param, [
        "analyticsName",
        "trackImpression",
        "inViewThreshold",
        "showDivider",
        "showBottomDivider",
        "isFullWidth",
        "variant",
        "disabled",
        "items",
        "titleAlign",
        "orientation",
        "defaultOpen"
    ]);
    var _$ref = (0,dist_cjs.useProps)(propsIn), _size = _$ref.size, size = _size === void 0 ? "medium" : _size;
    var singleValue, multipleValue;
    defaultOpen && (items.length > 1 ? multipleValue = items.map(function(item) {
        return item.title;
    }) : items.length > 0 && (singleValue = items[0].title));
    var accordionItems = items === null || items === void 0 ? void 0 : items.map(function(accordionItem, idx) {
        return /* @__PURE__ */ (0,jsx_runtime.jsx)(Accordion_AccordionItem, {
            showDivider: idx !== items.length - 1 ? showDivider : showDivider && showBottomDivider,
            isFullWidth: isFullWidth,
            disabled: disabled,
            variant: variant,
            size: size,
            title: accordionItem.title,
            description: accordionItem.description,
            titleAlign: titleAlign,
            orientation: orientation,
            analyticsName: analyticsName,
            suffix: accordionItem.suffix,
            eyebrowText: accordionItem.eyebrowText,
            defaultOpen: defaultOpen
        }, accordionItem.title);
    }), accordion = accordionItems.length > 1 ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Accordion, {
        overflow: "hidden",
        defaultValue: multipleValue,
        type: "multiple",
        children: accordionItems
    }) : /* @__PURE__ */ (0,jsx_runtime.jsx)(Accordion, {
        overflow: "hidden",
        defaultValue: singleValue,
        type: "single",
        collapsible: !0,
        children: accordionItems
    });
    return analyticsName && trackImpression ? /* @__PURE__ */ (0,jsx_runtime.jsx)(analytics/* ComponentWithViewTracking */.o, {
        Component: accordion,
        analyticsName: analyticsName,
        eventName: "accordionViewEvent",
        inViewThreshold: inViewThreshold,
        ref: ref
    }) : accordion;
}), Accordion_AccordionItem = function(param) {
    var showDivider = param.showDivider, isFullWidth = param.isFullWidth, disabled = param.disabled, title = param.title, description = param.description, size = param.size, variant = param.variant, titleAlign = param.titleAlign, orientation = param.orientation, analyticsName = param.analyticsName, suffix = param.suffix, eyebrowText = param.eyebrowText, defaultOpen = param.defaultOpen;
    var showSuffix = !isFullWidth && suffix, trackJourneyEvent = (0,useObservabilitySafe/* useObservabilitySafe */.r)().trackJourneyEvent, ref = (0,react.useState)(defaultOpen !== null && defaultOpen !== void 0 ? defaultOpen : !1), isOpen = ref[0], setIsOpen = ref[1];
    var triggerColor = "$contentPrimary";
    disabled && (triggerColor = accordionTokens.color.content.state.inactive);
    var handlePress = function() {
        setIsOpen(function(prevIsOpen) {
            return !prevIsOpen;
        }), analyticsName && trackJourneyEvent("platform", "accordionClickEvent", {
            targetName: analyticsName,
            accordionName: title
        });
    };
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(Accordion.Item, {
        value: title,
        "data-testid": "accordionTamagui-item",
        flexDirection: orientation === "top" ? "column" : "column-reverse",
        borderBottomWidth: showDivider ? "$default" : 0,
        borderBottomColor: showDivider ? "$borderPrimary" : "unset",
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsxs)(Accordion.Trigger, {
                height: accordionTokens.size.height[size],
                gap: accordionTokens.padding.betweenEyebrowAndValueText[size],
                justifyContent: "center",
                backgroundColor: "$transparent",
                borderWidth: 0,
                onPress: handlePress,
                focusVisibleStyle: {
                    // Make sure all of the outline is visible, even with overflow="hidden"
                    outlineOffset: -1
                },
                paddingHorizontal: 0,
                disabled: disabled,
                pointerEvents: disabled ? "none" : "auto",
                children: [
                    eyebrowText && /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        alignItems: titleAlign === "right" ? "flex-end" : "flex-start",
                        paddingRight: "$12x",
                        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            tag: "span",
                            typography: accordionTokens.typography.eyebrow.default,
                            fontWeight: accordionTokens.fontWeight.eyebrowOverride,
                            color: accordionTokens.color.content.eyebrow,
                            children: eyebrowText
                        })
                    }),
                    /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: isFullWidth ? "space-between" : titleAlign === "right" ? "flex-end" : "flex-start",
                        columnGap: accordionTokens.padding.betweenTextChevron.default,
                        children: [
                            /* @__PURE__ */ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                tag: "span",
                                typography: accordionTokens.typography[size][variant],
                                fontWeight: variant === "regular" ? accordionTokens.fontWeight.valueTextOverride : void 0,
                                color: triggerColor,
                                textAlign: "left",
                                children: title
                            }),
                            /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                rotate: isOpen ? "180deg" : "0deg",
                                animation: "accelerateDecelerateFastest",
                                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {
                                    size: 20,
                                    color: triggerColor
                                })
                            }),
                            showSuffix && /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                flexGrow: 1,
                                children: suffix
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(HeightAnimator_HeightAnimator, {
                isOpen: isOpen,
                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Accordion.Content, {
                    enterStyle: {
                        opacity: 0
                    },
                    exitStyle: {
                        opacity: 0
                    },
                    animation: "accelerateDecelerateFastest",
                    paddingBottom: accordionTokens.padding.betweenContentAndDivider[size],
                    children: typeof description == "string" ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        children: description
                    }) : description
                })
            })
        ]
    });
};



/***/ }),

/***/ 438497:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gm": function() { return /* reexport */ useDirection; }
});

// UNUSED EXPORTS: DirectionProvider, Provider

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
;// CONCATENATED MODULE: ./node_modules/@tamagui/use-direction/dist/esm/useDirection.mjs


const DirectionContext = react.createContext(void 0),
  DirectionProvider = props => {
    const {
      dir,
      children
    } = props;
    return /* @__PURE__ */jsx(DirectionContext.Provider, {
      value: dir,
      children
    });
  };
function useDirection(localDir) {
  const globalDir = react.useContext(DirectionContext);
  return localDir || globalDir || "ltr";
}
const Provider = (/* unused pure expression or super */ null && (DirectionProvider));

//# sourceMappingURL=useDirection.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/use-direction/dist/esm/index.mjs

//# sourceMappingURL=index.mjs.map


/***/ })

}]);